import { BrowserRouter as Router } from "react-router-dom";

import AppLayout from "./components/AppLayout";
import "./App.css";
import HeaderComponent from "./components/Header";
import { Helmet } from "react-helmet";

function App() {
  return (
    <Router>
      <Helmet>
        <link rel="icon" href="/favicon.png" />
      </Helmet>
      {window.location.pathname !== "/" && <HeaderComponent />}
      <div className="mt-[48px] md:mt-[72px]">
        <AppLayout />
      </div>
    </Router>
  );
}

export default App;
